import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadMemberActivationBatch = (formData) =>
  axios.post(`${BASE_URL}/members/batch-activation/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

export const getMemberActivationBatchUploadHistory = (params) =>
  axios.get(`${BASE_URL}/members/batch-activation/uploads`, {
    params,
    headers: getAuthHeaders(),
  });

export const getMemberActivationBatchProcessedRows = (uploadId, params) =>
  axios.get(`${BASE_URL}/members/batch-activation/processed/${uploadId}`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportMemberActivationBatchProcessedRows = (uploadId, params) =>
  axios.post(
    `${BASE_URL}/members/batch-activation/processed-export/${uploadId}`,
    {},
    {
      params,
      headers: getAuthHeaders(),
      responseType: "blob",
    }
  );

export const refreshMemberActivationBatchUploadSignedUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/members/batch-activation/refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );

